export default {
  methods: {
    popupMessage(msg) {
      let self = this
      let msgHtml = `<div style='padding: 0px;padding-top: 10px;'> <h3>${msg.title}</h3>${msg.body}</div>`
      this.$root.$confirm(`Message from ${msg.from}`, msgHtml, { 
        html: true,
        width: 500,
        color: 'red' , 
        ok: 'Read',
        cancel: 'Close',
        timeout: 10000}).then((confirm) => {
          if (confirm) {
            self.$root.$confirm(
              msg.title, 
              `<div>
              <p>${msg.body}</p>
              <p>${msg.expanded}</p>
              </div>`,
              {
                width: 700,
                nocancel: true,
                ok: 'OK'
            })
          } 
      })
    }
  }
}